import React from 'react'
import blog2 from "../../src/assets/images//khojgraphics/Campus (Inside Page).png";


function AboutCampusPage() {
  return (
    <section className="blog-detail-section">
      <div className="container">
        <div className="wrap-blog-detail blog-detail blog-detail-side-bar-content">
          <div className="widget-blog-1">
            <div className="content">
              {/* <span className="sub-title">Makerting</span> */}
              <h3 className="main-heading About-main-Heading">
                Campus : Empowering Institutions to Shape Future-Ready Professionals
              </h3>
              {/* <ul className="meta">
                        <li className="author">
                            <span>by</span>Avitex
                        </li>
                        <li className="time">
                            <span className="icon-calendar"></span> 2 days ago
                        </li>
                    </ul> */}
            </div>
            <div className="image">
              <img
                src={blog2}
                alt=""
              />
            </div>

          </div>
          <p className='pt-4'>
            Academic institutions are the bedrock of future talent, and Khoj is dedicated to equipping
            them with the tools and resources needed to nurture excellence. The robust platform ensures
            that candidates gain visibility, skill enhancement, and access to promising opportunities.
          </p>

          <h5 className='f-600'>Ensuring Better Visibility Among Potential Recruiters:</h5>
          <p>
            Elevate your recruitment efficiency with Khoj’s carefully designed aptitude assessments. These evaluations
            are not just tests; they are tools that reveal the true potential of your candidates. By measuring core
            competencies and showcasing their strengths, these assessments provide recruiters with in-depth insights
            that go beyond a resume, ensuring that your candidates stand out in a competitive job market. By integrating
            these evaluations into your recruitment process, your institution can enhance its reputation as a trusted
            source of well-prepared, highly skilled candidates.
          </p>

          <h5 className='f-600' style={{textTransform: "none"}}>Train Your Students for Success:</h5>
          <p>
            Prepare your students for the real world with Khoj’s tailored training modules. Our expertly curated programs are designed
            to equip students with the industry-relevant skills and knowledge they need to excel in today’s competitive job market.
            From honing technical skills to mastering soft skills like communication and interview techniques, Khoj ensures your students
            are fully prepared to secure high-value job offers and achieve their career goals. With our training, students don’t just meet
            industry expectations—they exceed them.
          </p>

          <h5 className='f-600'  style={{textTransform: "none"}}>Career Assistance to Your Students Even After They Graduate:</h5>
          <p>
            Khoj is committed to supporting students not just until they graduate, but for the crucial first five years of their corporate journey.
            As one of the pioneering platforms in career assistance, Khoj partners with campuses to provide structured career support, ensuring that
            students successfully transition from academia to the professional world. With just one registration, students gain access to mentorship,
            career counseling, skill enhancement programs, networking opportunities, and industry insight — all designed to help them navigate initial
            workplace challenges and advance in their careers. Because at Khoj, we believe that a strong foundation leads to sustained professional success.

          </p>

          <h5 className='f-600'  style={{textTransform: "none"}}>Collaborate for Enhanced Exposure:</h5>
          <p>
            Elevate your institution’s visibility and influence by collaborating with Khoj to host impactful conferences, insightful conclaves, and immersive
            industry tours. These collaborative initiatives create powerful opportunities for students to connect with industry professionals, thought leaders,
            and potential employers. By fostering these relationships, Khoj helps bridge the gap between academia and industry, enriching the educational experience
            and ensuring that your students are not only job-ready but also industry-aware. Through these collaborations, your institution can establish itself as
            a leader in providing students with valuable exposure to the real-world professional landscape.
          </p>

        </div>
      </div>
    </section>
  )
}

export default AboutCampusPage